module.exports = __webpack_public_path__ + "static/media/guide_en.1c1034d6.pdf";